import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
export const BoxEmpty = ({ message, height }) => (_jsx(Box, Object.assign({ display: "flex", justifyContent: "center", alignItems: "center", height: height }, { children: _jsx(Typography, Object.assign({ variant: "h5" }, { children: message })) })));
